// JavaScript Document
$(window).load(function(){

	var slider = ".slider ul";
	var thumbnailItem = "#lookThumb a";
	var indexClick;
	var nextSlide;

	$("#lookThumb li:first-child a").addClass("thumbnail-current");

	$(thumbnailItem).each(function() {
		var index = $(thumbnailItem).index(this);
		$(this).attr("data-index", index);
	});

	$(slider).on('init', function(slick) {
		var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
		$(thumbnailItem + '[data-index="' + index + '"]').addClass("thumbnail-current");
	});

/*
	$(thumbnailItem).on('click', function() {
		var index = $(this).attr("data-index");
		$(slider).slick("slickGoTo", index, false);
	});
*/

	$(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		$(thumbnailItem).each(function() {
			$(this).removeClass("thumbnail-current");
		});

		$(thumbnailItem + '[data-index="' + nextSlide + '"]').addClass("thumbnail-current");
	});

	if ($(window).width() < 769) {
		//for SP
	
		//サムネイルをクリックしたとき
		$(thumbnailItem).on('click', function() {
			//クリックした番号
			indexClick = $(this).attr("data-index");
			
			//飛び先のスライド
			nextSlide = $(".slider ul .slick-slide").eq(indexClick);

			//飛び先のスライドの画像をロードしたら
			nextSlide.find("img").imagesLoaded( function(){
				//console.log("loaded");

				//スライド移動開始
				$(slider).slick("slickGoTo", indexClick, false);

				//ページトップに
				setTimeout(function() {
					$("html,body").animate({
						scrollTop: 0
					}, 800, "easeInOutExpo");
				}, 0);			
			});				
		});		

		//adaptiveHeightと同じことをもう一度行う
		$(slider).on('init afterChange lazyLoaded', function(){
			var heightActiveSlider = $('.slider ul .slick-active').height();
			//console.log(heightActiveSlider);
			
			//スライダーの高さをかえる
			$(slider).height(heightActiveSlider);
			
			//スライドの高さをかえる　.slick-listにheight: auto !important;を追加
			$(slider).find(".slick-list").height(heightActiveSlider);
		});

		$(slider).slick({
			autoplay: false,
			fade: true,
			speed: 400,
			autoplaySpeed: 0,
			arrows: true,
			adaptiveHeight: true,
			lazyLoad: 'ondemand'
		});

		setTimeout(function() {
			var spH = $(".slider li img").height();
			var crh = $("#stylingImgMain li:first-child .lookCredit").height();
			var fsH = spH + crh;
			$(".slick-prev, .slick-next").css("top", spH + 23 + "px");
			$(".slick-list").css("height", fsH + 30 + "px");

		}, 400);


	} else {
		//for PC
		//サムネイルをクリックしたとき
		$(thumbnailItem).on('click', function() {
			var index = $(this).attr("data-index");
			$(slider).slick("slickGoTo", index, false);
		});

		$(slider).slick({
			autoplay: false,
			fade: true,
			speed: 400,
			autoplaySpeed: 400,
			arrows: true,
			lazyLoad: 'ondemand',
		});

		$("#lookThumb li:nth-child(1) div, #lookThumb li:nth-child(2) div, #lookThumb li:nth-child(3) div, #lookThumb li:nth-child(4) div, #lookThumb li:nth-child(5) div, #lookThumb li:nth-child(6) div, #lookThumb li:nth-child(7) div, #lookThumb li:nth-child(8) div, #lookThumb li:nth-child(9) div, #lookThumb li:nth-child(10) div, #lookThumb li:nth-child(11) div, #lookThumb li:nth-child(12) div").removeClass("fade_off");

		var h = $(window).height();
		var imgH = $("#itemImg").height();
		var creH = $("#itemCreditInner").height();
		var difH = h - creH;
		var itmH = $("#lookThumb").height();
		var styH = $("#stylingImg").height();
		var difH2 = itmH - styH;

		$("#itemCredit").height(imgH);
		$("#itemCreditInner").css("top", difH);
		$("#stylingImgInner").height(difH2 - 3);
		$("#stylingL").height(styH);

		$(window).resize(function() {
			var h = $(window).height();
			var imgH = $("#itemImg").height();
			var creH = $("#itemCreditInner").height();
			var difH = h - creH;
			var itmH = $("#lookThumb").height();
			var styH = $("#stylingImg").height();
			var difH2 = itmH - styH;

			$("#itemCredit").height(imgH);
			$("#itemCreditInner").css("top", difH);
			$("#stylingImgInner").height(difH2 - 2);
			$("#stylingL").height(styH);

		});
	}




});